/* eslint-disable react/jsx-props-no-spreading */
import classNames from 'classnames';

import { useThemeClassName } from '../../contexts/ThemeContext';
import TextsFeedback from './TextsFeedback';

import styles from '../../../styles/animations/coors-feedback.module.scss';

import canImage from '../../../img/coorslive/coorslight_can_omega.png';

// Ensure the path is correct

interface CoorsFeedbackProps {
    className?: string | null;
    image?: string;
    valid?: boolean | null;
}

function CoorsFeedback({
    className = null,
    valid = null,
    image = canImage,
    ...props
}: CoorsFeedbackProps) {
    const themeClassName = useThemeClassName(styles);
    return (
        <TextsFeedback
            className={classNames([
                styles.container,
                themeClassName,
                {
                    [styles.valid]: valid === true,
                    [styles.invalid]: valid === false,
                },
                className,
            ])}
            valid={valid}
            {...props}
        >
            <img src={image} alt="Coorslight" className={styles.can} />
        </TextsFeedback>
    );
}

export default CoorsFeedback;
